import { LOADED_PAGE } from "../actions/checkoutStore";

const _sentPages = new Set(); // keep track of which pages we've already emitted for

export default function GoogleEventManager(action, store) {
  if (
    action.type !== LOADED_PAGE ||
    !store.checkoutStore ||
    typeof window.gtag !== "function"
  )
    return;

  const page = action.payload.page;

  if (_sentPages.has(page)) return;

  _sentPages.add(page);

  const { analytics_data } = store.checkoutStore;

  switch (page) {
    case "checkout":
      emitInitiateCheckout(analytics_data);
      break;
    case "shipping":
      emitShippingCheckout(analytics_data);
      break;
    case "payment":
      emitPaymentCheckout(analytics_data);
      break;
  }
}

function emitInitiateCheckout({ order, order_items }) {
  window.gtag("event", "begin_checkout", {
    currency: order.currency,
    items: order_items,
    value: order.total || 0,
  });
}

function emitShippingCheckout({ order, order_items }) {
  window.gtag("event", "add_shipping_info", {
    currency: order.currency,
    items: order_items,
    value: order.total || 0,
  });
}

function emitPaymentCheckout({ order, order_items }) {
  window.gtag("event", "add_payment_info", {
    currency: order.currency,
    items: order_items,
    value: order.total || 0,
  });
}
